import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchMaintenanceInfo } from '@/state/slice/maintenanceSlice';
import { AppDispatch } from '@/state';

const useMaintenanceCheck = () => {
	const dispatch = useDispatch<AppDispatch>();
	const location = useLocation();

	useEffect(() => {
		dispatch(fetchMaintenanceInfo());
	}, [location.pathname, location.search, dispatch]);
};

export default useMaintenanceCheck;
